import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@shared/utils/models/http.model';
import { catchError, of, forkJoin, mergeMap, switchMap } from 'rxjs';
import { LicenseService } from '../services/license.service';
import { LicenseActions } from '../actions/license.action';
import { Action } from '@ngrx/store';
import { UserActions } from '../actions/user.actions';

@Injectable()
export class LicenseEffects {
  private readonly licenseService = inject(LicenseService);
  private readonly actions$ = inject(Actions);

  bulkUpdateLicenses$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LicenseActions.bulkUpdateLicenses),
      mergeMap((action) =>
        forkJoin([
          action.add.length ? forkJoin(action.add.map((license) => this.licenseService.addLicense(license))) : of(null),
          action.delete.length ? this.licenseService.deleteLicense(action.delete.map(({ id }) => id)) : of(null),
        ]).pipe(
          switchMap((response) => {
            const actions: Action[] = [LicenseActions.bulkUpdateLicensesSuccess()];
            if (response.some(Boolean)) {
              actions.push(UserActions.getProfile());
            }
            return actions;
          }),
          catchError((error: HttpError) => of(LicenseActions.bulkUpdateLicensesFailure({ error })))
        )
      )
    );
  });
}
